import { Box, Typography } from '@mui/material'
import React from 'react'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { t } from '@lingui/macro';
import { Link } from 'react-router-dom';
import StyledButton from './StyledButton';
import StyledPaper from './StyledPaper';
import appRoutes from '../utils/routes';

type CheckoutHeaderProps = {
    restaurantName: string
    headerTitle?: string
    redirectUrl?: string
    onBackClick?: () => void
}
const CheckoutHeader: React.FC<CheckoutHeaderProps> = (props) => {
    const { restaurantName, headerTitle, redirectUrl, onBackClick } = props;
    const handleClick = () => {
        if (onBackClick) {
            onBackClick()
        }
      };

    return <Box display={'flex'} >
        <StyledPaper sx={{ display: 'flex', justifyContent: 'center', padding: 0, width: '48px', height: '48px', mr: '12px' }}>
            <Link onClick={handleClick} style={{ height: '100%', width: '100%' }} to={redirectUrl || appRoutes.menu}>
                <StyledButton sx={{ height: '100%', width: '100%', minWidth: 'unset' }}>
                    <ArrowBackIcon />
                </StyledButton>
            </Link>
        </StyledPaper>
        <Box flex='1'>
            <Typography variant='subtitle2'>{restaurantName}</Typography>
            <Typography variant='h5'>{headerTitle || t`Menu`}</Typography>
        </Box>
    </Box>
}

export default CheckoutHeader;